import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.title);

  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" });
      NProgress.done();
    } else {
      // let registerRouteFresh = true
      // if (registerRouteFresh) {
      //   // addRoute允许带children添加，所以循环第一层即可
      //   // dynamicRouter(menu).forEach((itemRouter) => {
      //   //   router.addRoute(itemRouter)
      //   // })
      // await store.dispatch("user/getMenu");
      //   const menuList = store.state.user.menuUrl;
      // //   if(menuList){
      // //     const accessRoutes  = await store.dispatch(
      // //       "permission/generateRoutes",
      // //       menuList
      // // );
      // router.options.routes.unshift({ path: "/", redirect: '/party/buildingList', hidden: true  })
      //   // router.addRoutes([{ path: "/", redirect: menuList , hidden: true }]);

      // // router.addRoutes(accessRoutes);

      //   registerRouteFresh = false
      //   // next({ ...to, replace: true })

      // } else {
      //   next()
      // }
      // )
      // if(menuList){
      //   const accessRoutes  = await store.dispatch(
      //     "permission/generateRoutes",
      //     menuList
      //   );
      //   router.addRoutes(accessRoutes);
      // }
      // await router.addRoutes([{ path: "/", redirect: menuList }]);

      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = true;
      // store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        await store.dispatch("user/getUrl");
        await store.dispatch("user/getRoles");
        await store.dispatch("user/getInfo");
        // await store.dispatch("user/getMenu");
        // const menuList = store.state.user.menuUrl;
        // router.addRoutes([{ path: '/', redirect: menuList }])
        // if(menuList){
        //   const accessRoutes  = await store.dispatch(
        //     "permission/generateRoutes",
        //     menuList
        //   );
        //   router.addRoutes(accessRoutes);
        // }
        // // dynamically add accessible routes
        next();
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const { roles } = await store.dispatch("user/getRoles");
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch(
            "permission/generateRoutes",
            roles
          );

          // dynamically add accessible routes
          router.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true });
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch("user/resetToken");
          Message.error(error || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
